import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PatientPageLayoutProps {
  title: ReactNode;
  children: ReactNode;
  footer: ReactNode;
  className?: string;
  columnClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
  footerClassName?: string;
}

export const PatientPageLayout = ({
  title,
  children,
  footer,
  className,
  columnClassName,
  titleClassName,
  contentClassName,
  footerClassName,
}: PatientPageLayoutProps) => {
  return (
    <div
      className={cn(
        'flex h-full flex-col n2xl:justify-start justify-between gap-4 px-4 n2xs:px-6 nsm:px-0 items-center',
        className,
      )}
    >
      <div
        className={cn(
          'flex flex-col nsm:min-h-120 gap-0 n2xs:gap-4 sm:max-w-86',
          columnClassName,
        )}
      >
        <header className={cn('shrink-0 nsm:px-10', titleClassName)}>
          {title}
        </header>
        <main
          className={cn(
            'flex overflow-y-auto nsm:px-10 no-scrollbar h-full',
            contentClassName,
          )}
        >
          {children}
        </main>
      </div>

      <footer
        className={cn(
          'shrink-0 px-6 pb-6 pt-4 nsm:pt-0 nsm:px-10 nsm:z-20',
          footerClassName,
        )}
      >
        {footer}
      </footer>
    </div>
  );
};
